export default {
    loading: {
        module: false
    },
    params: {
        date :[]
    },
    data_report : [],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-picking/state.js